<template>
  <div class="main-log">
    <main>
      <header>
        <h3>流程日志</h3>
        <!-- <span>/ computer management</span> -->
        <div class="btn-group">
          <a-popconfirm
              title="导出的表格数据量最大支持5000，确定要导出吗？"
              ok-text="确定"
              cancel-text="取消"
              :disabled="jobExportDis"
              @confirm="exportjobLog"
          >
            <a-button  icon="download"    :disabled="jobExportDis"  >导出</a-button>
          </a-popconfirm>
        </div>
      </header>
      <!-- 表格搜索栏 -->
      <div class="toolbar">
        <a-form-model :model="pagination" ref="searchBar" :layout="formLayout">
          <a-form-model-item prop="searchText">
            <a-input-search placeholder="作业编号/流程/机器人/消息" style="width: 230px;" allow-clear :loading="btnLoad"
                            v-model.trim="pagination.searchText" @input="searchTextChange" />
          </a-form-model-item>
          <a-form-model-item prop="logLevel" >
            <a-select placeholder="日志级别" v-model="pagination.logLevel" style="width: 180px;" :loading="btnLoad"
                      allow-clear @change="searchChange">
              <a-select-option value="1">消息</a-select-option>
              <a-select-option value="2">警告</a-select-option>
              <a-select-option value="3">错误</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="orgId">
            <a-tree-select
                v-model='pagination.orgId'
                allowClear
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="treeData"
                style="width: 180px; "
                @change="searchChange"
                placeholder="选择部门"
                show-search
                :filterTreeNode="filter_tree_node"
                tree-default-expand-all
                :replaceFields="{ title: 'name', key: 'id',value:'id' }"
            >
            </a-tree-select>
          </a-form-model-item>
          <a-form-model-item prop="time">
            <a-range-picker :value="pagination.time" v-model="pagination.time"
                            :placeholder="['操作时间: 开始', '操作时间: 结束']"  valueFormat="YYYY-MM-DD" style="width: 300px;" @change="searchChange" />
          </a-form-model-item>
          <a-form-model-item >
            <a-button @click="resetSearch">重  置</a-button>
          </a-form-model-item>
        </a-form-model>

      </div>
      <!-- 数据表格 -->
      <a-table :columns="tableColumns" bordered  :data-source="tableData" :loading="tableLoad" :pagination="queryCondition"
               @change="handleTableChange" :scroll="{ y: 560 }">
        <template slot="logLevel" slot-scope="text">


          <a-tag :color=" logLevelDict[text].color">  {{ logLevelDict[text].text }}</a-tag>

        </template>
        <span slot="num" slot-scope="text, record, index">
          {{  (Page.current - 1) * Page.pageSize + parseInt(index) + 1  }}
        </span>
      </a-table>
    </main>

  </div>
</template>

<script>
export default {
  data() {
    return {
      btnLoad: false,
      tableLoad: false,
      pagination: {
        searchText: "",
        time:[],
        logLevel:undefined,
        pageSize: 10,
        pageNo: 1,
        total: 0,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showTotal: (total, range) => `显示 ${range[0]} 到 ${range[1]} ，共 ${total} 条记录  `
      },
      formLayout:"inline",
      queryCondition:{},
      tableColumns: [
        {
          title: "序号",
          dataIndex: "index",
          key: "index",
          align: "center",
          width: 65 ,
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: '时间',
          dataIndex: "createTime",
          key: "createTime",
          width: 180,
          ellipsis: true,
        },
        {
          title: "级别",
          dataIndex: "logLevel",
          key: "logLevel",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "logLevel" },
        },
        {
          title: "作业编号",
          dataIndex: "jobKey",
          key: "jobKey",
          ellipsis: true
        },
        {
          title: "流程",
          dataIndex: "processName",
          key: "processName",
          ellipsis: true
        },
        {
          title: "部门",
          dataIndex: "orgName",
          key: "orgName",
          ellipsis: true,
        },
        {
          title: "机器人",
          dataIndex: "robotName",
          key: "robotName",
          ellipsis: true
        },
        {
          title: "消息",
          dataIndex: "msg",
          key: "msg",
          ellipsis: true
        },

      ],
      tableData: [],
      addFormRules: {
        name: [{ required: true, message: "计算机名称不能为空" }],
        type: [{ required: true, message: "类型不能为空" }],
      },
      detailsData:[],
      modalVisible:false,
      jobExportDis:false,
      // 操作类型
      stateList:{},
      treeData:[],

      logLevelDict: {
        1:{
          color:'green',
          text:"消息"
        },
        2:{
          color:'orange',
          text:"警告"
        },
        3:{
          color:'red',
          text:"错误"
        }
      },
    };
  },
  methods: {
    // 部门筛选
    filter_tree_node( input,node ) {
      if ( node.children == null ) {
        if ( node.componentOptions.propsData.title.indexOf( input ) !=-1 ) {
          return true;
        } else {
          return false;
        }
      }
    },
    // 部门下拉框
    allorgList() {
      this.axios
          .post("/org/findOrg",'')
          .then((res) => {
            if (res.code === 200) {
              this.treeData = res.data;
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 重置搜索
    resetSearch(){
      this.$refs.searchBar.resetFields()
      this.pagination.current  = 1
      this.searchChange()
    },
    // 导出
    exportjobLog(title){
      let exportParam = {},exportApi = '';
      exportParam = this.$lodash.cloneDeep(this.pagination)
      exportApi = '/jobLog/export'
      exportParam.time = exportParam.time ? exportParam.time.join(',') : ''

      this.axios.post(exportApi, exportParam, { responseType: 'blob' }).then((res)=>{
        const blob = new Blob([res], {
          type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
        });
        if (window.navigator.msSaveBlob) {          //IE兼容处理
          try {
            window.navigator.msSaveBlob(blob,fileName+'.xlsx');
          } catch (e) {
            console.log(e);
          }
        } else {
          const url = window.URL.createObjectURL(blob);
          const aLink = document.createElement("a");
          aLink.style.display = "none";
          aLink.href = url;
          aLink.setAttribute("download", '流程日志');
          document.body.appendChild(aLink);
          aLink.click();
          document.body.removeChild(aLink); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      }).catch((err)=>{
        console.log(err.message);
      })


    },
    // 查看详情
    detail(data){
      this.modalVisible = true
      this.detailsData = []
      this.axios
          .get("/syslog/getById/" + data.id )
          .then((res) => {
            console.log(res)
            if (res.code === 200) {
              let allData = []
              JSON.parse( res.data.params ).forEach((v)=>{
                if ( res.data.sysLogAudit){
                  JSON.parse( res.data.sysLogAudit.recContent ).forEach((b)=>{
                    if (v.propertyName == b.propertyName){
                      v.newValue = b.newValue
                      v.oldValue = b.oldValue
                    }
                  })
                }

                allData.push(v)
              })
              this.detailsData = allData
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 打开模态框
    handleOpen(title) {
      this.modalTitle = title;
      this.modalVisible = true;
      switch (title) {
        case "添加":
          break;
        case "修改":
          break;
        case "删除":
          break;
      }
    },
    // 确认模态框
    handleOk() {
      console.log("OK");
    },
    // 监听搜索输入框输入
    searchTextChange(val) {
      if (window.searchTimer) {
        clearTimeout(searchTimer);
      }
      window.searchTimer = setTimeout(() => {
        this.searchChange(val)
      }, 1200);
    },
    // 搜索
    searchChange(v) {
      this.queryCondition = this.$lodash.cloneDeep(this.pagination)
      this.queryCondition.time = this.queryCondition.time ? this.queryCondition.time.join(',') : ''
      this.tableAjax()
    },
    // 监听翻页
    handleTableChange(pagination, filters, sorter) {
      this.queryCondition.pageNo = pagination.current
      this.queryCondition.current = pagination.current
      this.queryCondition.pageSize = pagination.pageSize
      this.tableAjax()
    },
    // 翻页请求
    tableAjax() {
      this.tableLoad = true;
      this.axios
          .post("/jobLog/findPage", this.$qs.stringify(this.queryCondition))
          .then((res) => {
            this.tableLoad = false;
            if (res.code === 200) {
              this.tableData = res.data.records;
              this.queryCondition.total = res.data.total;
              if (this.tableData.length  == 0){
                this.jobExportDis = true
              }else{
                this.jobExportDis = false
              }
            }
          })
          .catch((err) => {
            console.log(err);
            this.tableLoad = false;
          });
    },
  },
  beforeMount() {
    this.searchChange()
    this.allorgList()

  }
};
</script>

<style lang="scss" scoped>
.main-log {


  main {
    margin: 16px;
    background-color: #fff;
    border-radius: 2px;

    header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid #f0f0f0;

      h3 {
        margin-bottom: 0;
        height: 18px;
        line-height:17px;
        padding-left: 12px;
        border-left: 4px solid #3373F2;
        font-size: 16px;
        font-weight: bold;
        color: #3d4966;
      }

      span {
        line-height: 16px;
        margin-left: 10px;
        color: #808080;
      }
    }

    .toolbar {
      display: flex;
      justify-content: space-between;
      padding: 16px;

      .search-bar {
        flex: 1;
      }
      .ant-form{
        .ant-form-item{
          margin-right: 16px;
        }
        .ant-form-item:last-child{
          .ant-btn{
            width: 74px;
            position: absolute;

          }
        }
      }
    }
    .ant-table-wrapper{
      padding: 0 16px 16px;
    }

    i.table-action {
      cursor: pointer;
      display: inline-block;
      margin: -5px 0;
      width: 30px;
      height: 30px;
      background: url("../assets/images/Table_action.png") no-repeat center;
      border-radius: 20px;
      vertical-align: top;

      &:active {
        background-color: #d8e6ff;
      }
    }


  }


}
.modifyContent{
  display: flex;
  width: 100%;
  justify-content: space-between;
  .front,.after{
    table{
      width: 340px;
      table, th, td {
        border: 1px solid #f3f3f3;
        padding:10px;
        border-radius: 4px;
      }

      tr{
        width: 100%;

        td:nth-child(1){
          width: 125px;
          color: #97a6b7;
          //font-weight: 600;
          font-size: 14px;
        }
        td:nth-child(2){
          color:#212121;
          //font-weight: 600;
          font-size: 15px;
          span{
            width: 210px;
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
}

</style>
